import Base from "../utils/base.js";
import Storage from "../utils/storage.js";
import generalMethod from "../utils/generalMethod.js";
import SyModel from "../models/sy.js";
import Report from "../utils/report";

/*
 *@description: 暴露方法（研发对接）
 *@author: 薛微微
 *@date: 2023-06-22 16:36:29
 */
import { RSSign } from "./sign.js";
import SdkModel from "../models/sdk";

// order_source 接口标记下单来源
const ORDER_SOURCE = 52;

// eslint-disable-next-line no-unused-vars
const GetOrderSource = (appid) => {
  return ORDER_SOURCE;
};

const RastarSdk = {
  // 下单
  myfunction(arr) {
    window.location.href = arr;
  },
  createOrder(payInfo, urlData, apiUrl) {
    console.log("研发传的参数payInfo=====", payInfo);
    let isCache = Storage.localStorageGet("deviceIdUa");
    if (!isCache) {
      // 不存在就强制刷新页面
      console.log("deviceIdUa isCache不存在");
      location.reload();
    } else {
      return new Promise((resolve) => {
        generalMethod
          .freezetoken(urlData.pid, urlData.appid, urlData.md_id)
          .then((res) => {
            if (res.code == 200) {
              let access_token = Storage.localStorageGet("access_token");
              let data = {
                ts: new Date().getTime(),
                cch_id: urlData.pid,
                app_id: urlData.appid,
                token: res.data,
                md_id: urlData.md_id,
                ad_id: urlData.ukey,
                time_zone: Base.timeZone(),
                nonce: Base.nonce(12),
                version: Base.getVersion(),
                cch_pay_data: "",
                access_token: access_token,
                order_amt: payInfo.order_amt,
                currency: payInfo.currency,
                app_order_no: payInfo.app_order_no,
                role_id: payInfo.role_id,
                role_name: payInfo.role_name,
                role_level: payInfo.role_level,
                server_id: payInfo.server_id,
                server_name: payInfo.server_name,
                app_subject: payInfo.app_subject,
                biz_region: "en",
                euser_region: localStorage.getItem("selected_region"),
                app_ext: payInfo.app_ext || "",
                order_source: GetOrderSource(urlData.appid), // 东南亚页游下单固定值
              };
              data.device_id = Storage.localStorageGet("deviceIdUa");
              data.sign = RSSign(data, data.app_id);
              console.log("下单data打印测试更新====", data);

              SyModel.createOrder(apiUrl.create_order, data).then((res) => {
                console.log("下单返回res===", res);
                if (res.code == 6004) {
                  console.log(6004);
                  resolve(6004);
                } else if (res.code == 6005) {
                  console.log(6005);
                  resolve(6005);
                } else if (res.code == 200) {
                  let system = Base.checkSysteam();
                  // 设置支付系统是pc 或者 wap
                  if (system === "PC") {
                    Report.webDotFather(
                      urlData.pid,
                      urlData.appid,
                      urlData.ukey,
                      "show_pcmsr_pay_index",
                    );
                  } else {
                    Report.webDotFather(
                      urlData.pid,
                      urlData.appid,
                      urlData.ukey,
                      "show_momsr_pay_index",
                    );
                  }
                  console.log("下单返回res.data===", res.data);
                  // 如果成功了就需要下发一条链接给研发   showTitlebar等于1在移动端会显示标题，否则不显示

                  // 因为东南亚只支持英文和泰语支付，所以需要特殊处理下语言参数 新增印尼语支持
                  let lang = Storage.localStorageGet("lang");
                  if (lang.substring(0, 2) == "th") {
                    lang = "th";
                  } else if (lang.substring(0, 2) == "id") {
                    lang = "id";
                  } else if (lang.substring(0, 2) == "vi") {
                    lang = "vi";
                  } else {
                    lang = "en";
                  }
                  let data = res.data.trade_data;
                  try {
                    const query = {
                      sdk_ver: Base.sdkVer(),
                      uinfo: Storage.getCookie("XH_U"),
                      sdk_type: "en",
                      client_type: "Web",
                      trans_info: JSON.stringify(data),
                    };
                    query.sign = RSSign(query, urlData.appid);
                    const payUrl = `${apiUrl.third_pay}?${Object.keys(query)
                      .map((key) => `${key}=${query[key]}`)
                      .join("&")}`;
                    console.log("支付链接payUrl===", payUrl);
                    // window.open(payUrl);
                    // 因为 window.open(payUrl); 在ios终端拉不起支付。所以要做下系统判断再打开支付页面
                    if (system == "PC") {
                      window.open(payUrl);
                    } else {
                      console.log("daimaa111");
                      this.myfunction(payUrl);
                    }
                    resolve(payUrl);
                  } catch (error) {
                    console.error(error);
                  }
                }
              });
            }
          });
      });
    }
  },
  // 角色信息数据上报
  async RaStarUpload(data, urlData, dataCollecInfo) {
    if (!window.Role) {
      window.Role = data.role_info;
    }
    let enter = data.action;
    data.tm = Date.parse(new Date()); //时间戳 秒
    data.cch_id = urlData.pid;
    data.app_id = urlData.appid;
    data.device_id = Storage.localStorageGet("deviceIdUa");
    data.ukey = urlData.ukey;
    data.action = enter;
    data.role_info = JSON.stringify(data.role_info);
    data.uinfo = JSON.stringify(dataCollecInfo);
    data.sdk_ver = Base.sdkVer();
    data.app_ver = "websdk";
    data.app_version_code = "1.0.0";
    data.sign = RSSign(data, data.app_id);
    console.log("打印角色上报所有打他数据", data);
    console.log("打印角色上报data.uinfo===", data.uinfo);
    // 获取了接口地址
    let suc = await SdkModel.RaStarUpload(data);
    if (suc.code == 200) {
      if (data.action == "enter") {
        console.log("角色进入服务器");
      } else if (data.action == "create") {
        console.log("创建游戏角色");
      } else if (data.action == "up_level") {
        console.log("角色升级");
      } else if (data.action == "update") {
        console.log("角色改名");
      } else {
        console.log("角色上报action错误");
      }
      console.log("角色上报成功");
    } else {
      console.log(suc.msg);
    }
  },
};
export default RastarSdk;
